import script from "./App.vue?vue&type=script&setup=true&language=ts&lang=js"
export * from "./App.vue?vue&type=script&setup=true&language=ts&lang=js"

const __exports__ = script;

export default __exports__